import { render, staticRenderFns } from "./menulistctrl.vue?vue&type=template&id=ce98697a&scoped=true"
import script from "./menulistctrl.vue?vue&type=script&lang=js"
export * from "./menulistctrl.vue?vue&type=script&lang=js"
import style0 from "./menulistctrl.vue?vue&type=style&index=0&id=ce98697a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce98697a",
  null
  
)

export default component.exports